export const validateFax = fax => {
    const re = /^([+])[0-9]{8,15}$/;
    return re.test(fax);
};

export const validatePhoneNo = phoneNo => {
    const regex = /^([+])[0-9]{8,15}$/;
    return regex.test(phoneNo);
};
